import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./ManaFalafel.Meal.scss"

class FalaFelMeal extends Component {
    constructor(props) {
        super()
        this.state = {
            isChoosen: false
        }
        this.chooseMeal = this.chooseMeal.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.item.ID == this.props.removeSelected) {
            this.setState({
                isChoosen: false
            })
        }
        if (this.props.item.ID == this.props.chooseMeal) {
            this.chooseMeal();
        }
    }
    chooseMeal() {
        if (!this.state.isChoosen && this.props.current >= 3) {
            this.props.triggerPopup({
                Title: "לא ניתן לבחור יותר מ-3 פלאפליות",
                Describe: ""
            }, "")
            //alert("לא ניתן לבחור יותר מ-3 מסעדות");
            return;
        }
        this.setState({
            isChoosen: !this.state.isChoosen
        })
        this.props.getMeal(this.props.item, (!this.state.isChoosen ? Math.round(this.props.current + 1) : Math.round(this.props.current - 1)));


    }
    render() {
        const image = {
            backgroundImage: `url(./static/images/manot/${this.props.item.Image}.jpg)`
        }
        return (
            <div className={`mana${(this.state.isChoosen ? " active" : "")}`}>
                <div className="mana-padding">
                    <div className="headline">
                        <h5>
                            {this.props.item.Title}
                        </h5>
                    </div>
                    <div className="image">
                        <div className="image-wrapper">
                            <div className="bgimage" style={image}></div>
                            <div className="mask"></div>
                            <div className="zoom" onClick={() => { push("Plus Clicked", `${this.props.item.Title} - ${this.props.item.City}`); this.props.triggerPopup(this.props.item, this.state.isChoosen) }}>
                                <div className="plus"></div>
                            </div>
                        </div>
                    </div>
                    <div className="city">
                        {this.props.item.City}
                    </div>
                    <div className="button" onClick={() => { push(`falafel - ${(!this.state.isChoosen ? "Add to List" : "Removed From List")}`, "Button"); this.chooseMeal() }}>
                        <div className="button-text">
                            {`${(this.state.isChoosen ? "בטל בחירה" : "בחירה")}`}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FalaFelMeal;



// WEBPACK FOOTER //
// ./src/Components/ManotFalafel/ManaFalafel.Meal.js